/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentTeamResponse } from './TournamentTeamResponse';
import {
    TournamentTeamResponseFromJSON,
    TournamentTeamResponseFromJSONTyped,
    TournamentTeamResponseToJSON,
    TournamentTeamResponseToJSONTyped,
} from './TournamentTeamResponse';

/**
 * Result of a team operation (check-in, update, etc.)
 * @export
 * @interface TeamOperationResponse
 */
export interface TeamOperationResponse {
    /**
     * 
     * @type {TournamentTeamResponse}
     * @memberof TeamOperationResponse
     */
    team: TournamentTeamResponse;
    /**
     * Operation result message
     * @type {string}
     * @memberof TeamOperationResponse
     */
    message: string;
}

/**
 * Check if a given object implements the TeamOperationResponse interface.
 */
export function instanceOfTeamOperationResponse(value: object): value is TeamOperationResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TeamOperationResponseFromJSON(json: any): TeamOperationResponse {
    return TeamOperationResponseFromJSONTyped(json, false);
}

export function TeamOperationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamOperationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': TournamentTeamResponseFromJSON(json['team']),
        'message': json['message'],
    };
}

export function TeamOperationResponseToJSON(json: any): TeamOperationResponse {
    return TeamOperationResponseToJSONTyped(json, false);
}

export function TeamOperationResponseToJSONTyped(value?: TeamOperationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': TournamentTeamResponseToJSON(value['team']),
        'message': value['message'],
    };
}

